import { useEffect, useState } from "react";
import {
  getDeploymentData,
  getEnvironments,
  getRepos,
  buildDeploymentTable,
  Environment,
  Deployment,
  FlattenedRepo,
  DeploymentTable,
} from "./service";
import Logger from "../utils/logger";

export const useDeployments = (onFetchComplete?: () => void) => {
  const [deploymentTable, setDeploymentTable] = useState<DeploymentTable>({});
  const [envs, setEnvs] = useState<Environment[]>([]);
  const [repos, setRepos] = useState<FlattenedRepo[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchData = async () => {
    Logger.info("Fetching deployment-related data...");
    try {
      // Fetch environments
      Logger.info("Fetching environments...");
      const environments: Environment[] = await getEnvironments();
      Logger.info("Environments fetched successfully", { environments });

      // Fetch repos
      Logger.info("Fetching repos...");
      const flattenedRepos: FlattenedRepo[] = await getRepos();
      Logger.info("Repos fetched successfully", { flattenedRepos });

      // Fetch deployments
      Logger.info("Fetching deployment data...");
      const deployments: Deployment[] = await getDeploymentData();
      Logger.info("Deployments fetched successfully", { deployments });

      // Build deployment table
      Logger.info("Building deployment table...");
      const table = buildDeploymentTable(
        flattenedRepos,
        environments,
        deployments
      );
      Logger.info("Deployment table built successfully", { table });

      // Update state
      setDeploymentTable(table);
      setEnvs(environments);
      setRepos(flattenedRepos);
      setIsLoading(false);

      Logger.info("State updated successfully");

      // Trigger optional callback after fetching
      if (onFetchComplete) onFetchComplete();
    } catch (error) {
      Logger.error("Error fetching deployment-related data", { error });
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return { deploymentTable, envs, repos, isLoading, fetchData };
};
